(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('jv-hero-slider')) return;

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    class JvHeroSlider extends HTMLElement {
      connectedCallback() {
        var d = this.dataset;
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-jvh-slide]'));
        this.count = this.slides.length;
        this.track = this.querySelector('[data-jvh-track]');
        this.viewport = this.querySelector('[data-jvh-viewport]');
        this.currentEl = this.querySelector('[data-jvh-current]');
        this.fillEl = this.querySelector('[data-jvh-fill]');
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-jvh-dot]'));
        this.segFills = Array.prototype.slice.call(this.querySelectorAll('[data-jvh-seg-fill]'));
        this.keepFilled = !!this.querySelector('.jvh--keep');
        this.autoHeader = d.headerOffset !== 'false';
        this.pauseBtn = this.querySelector('[data-jvh-pause]');
        this.mode = d.mode === 'slide' ? 'slide' : 'fade';
        this.loop = d.loop !== 'false';
        this.delay = Math.max(2, parseFloat(d.speed) || 6) * 1000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = d.autoplay === 'true' && this.count > 1 && !this.reduced;
        this.holds = new Set();
        this.userPaused = false;
        this.timer = null;
        this.remaining = this.delay;
        this.startedAt = 0;
        this.index = 0;
        if (!this.count) return;

        this.goTo(0);
        var self = this;
        this.measureHeader();
        var rz = null;
        var onResize = function () { clearTimeout(rz); rz = setTimeout(function () { self.measureHeader(true); }, 120); };
        window.addEventListener('resize', onResize, { passive: true });
        window.addEventListener('load', function () { self.measureHeader(true); }, { once: true });
        window.addEventListener('scroll', function () { if (self._hdr == null && window.scrollY < 10) self.measureHeader(); }, { passive: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.measureHeader(true); });
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.classList.add('is-ready'); }); });
        if (this.count < 2) return;

        this._ac = new AbortController();
        var opt = { signal: this._ac.signal };

        var prevBtn = this.querySelector('[data-jvh-prev]');
        var nextBtn = this.querySelector('[data-jvh-next]');
        if (prevBtn) prevBtn.addEventListener('click', function () { self.prev(); }, opt);
        if (nextBtn) nextBtn.addEventListener('click', function () { self.next(); }, opt);
        this.dots.forEach(function (dot, i) { dot.addEventListener('click', function () { self.goTo(i); }, opt); });
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', function () {
            self.userPaused = !self.userPaused;
            self.updatePauseBtn();
            self.schedule();
          }, opt);
        }

        if (d.pauseHover === 'true') {
          this.addEventListener('mouseenter', function () { self.hold('hover'); }, opt);
          this.addEventListener('mouseleave', function () { self.release('hover'); }, opt);
        }
        this.addEventListener('focusin', function (e) {
          if (e.target.matches && e.target.matches(':focus-visible')) self.hold('focus');
        }, opt);
        this.addEventListener('focusout', function (e) {
          if (!self.contains(e.relatedTarget)) self.release('focus');
        }, opt);
        this.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); }
        }, opt);

        if (d.swipe !== 'false' && this.viewport) {
          var x0 = null, y0 = 0;
          this.viewport.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            x0 = e.clientX; y0 = e.clientY;
          }, opt);
          this.viewport.addEventListener('pointerup', function (e) {
            if (x0 === null) return;
            var dx = e.clientX - x0, dy = e.clientY - y0;
            x0 = null;
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
              self.swiped = true;
              if (dx < 0) self.next(); else self.prev();
              setTimeout(function () { self.swiped = false; }, 60);
            }
          }, opt);
          this.viewport.addEventListener('pointercancel', function () { x0 = null; }, opt);
          this.viewport.addEventListener('click', function (e) {
            if (self.swiped) { e.preventDefault(); e.stopPropagation(); }
          }, { capture: true, signal: this._ac.signal });
        }

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) self.release('offscreen'); else self.hold('offscreen');
          }, { threshold: 0.2 });
          this.io.observe(this);
        }
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) self.hold('hidden'); else self.release('hidden');
        }, opt);

        /* Shopify theme editor: show the slide being edited and pause */
        document.addEventListener('shopify:block:select', function (e) {
          var i = self.slides.indexOf(e.target);
          if (i > -1) { self.hold('editor'); self.goTo(i); }
        }, opt);
        document.addEventListener('shopify:block:deselect', function (e) {
          if (self.slides.indexOf(e.target) > -1) self.release('editor');
        }, opt);

        this.updatePauseBtn();
        this.schedule();
      }

      disconnectedCallback() {
        if (this._ac) this._ac.abort();
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
      }

      /* Transparent header: if the theme header is absolutely/fixed positioned
         over the top of this slider, push the content down by the overlap. */
      measureHeader(force) {
        if (!this.autoHeader) { this.style.setProperty('--jvh-hdr', '0px'); return; }
        if (window.scrollY > 10 && this._hdr != null) return;
        if (window.scrollY > 10 && !force) return;
        var top = this.getBoundingClientRect().top;
        var o = 0;
        var els = document.querySelectorAll('.shopify-section-group-header-group, #shopify-section-header, header, sticky-header, .header-wrapper, .section-header');
        for (var k = 0; k < els.length; k++) {
          var el = els[k];
          if (el === this || this.contains(el)) continue;
          var pos = getComputedStyle(el).position;
          if (pos !== 'absolute' && pos !== 'fixed') continue;
          var r = el.getBoundingClientRect();
          if (!r.height || r.top > top + 2 || r.bottom <= top) continue;
          o = Math.max(o, r.bottom - top);
        }
        o = Math.min(Math.round(o), 320);
        this._hdr = o;
        this.style.setProperty('--jvh-hdr', o + 'px');
      }

      hold(reason) { this.holds.add(reason); this.schedule(); }
      release(reason) { this.holds.delete(reason); this.schedule(); }

      /* Progress line: with autoplay it fills 0 -> 100% over the slide time */
      setFill(from, ms) {
        var f = this.segFills.length ? this.segFills[this.index] : this.fillEl;
        if (!f) return;
        f.style.transition = 'none';
        f.style.width = (Math.min(1, Math.max(0, from)) * 100) + '%';
        if (ms > 0) {
          void f.offsetWidth;
          f.style.transition = 'width ' + ms + 'ms linear';
          f.style.width = '100%';
        }
      }

      schedule() {
        if (this.timer) {
          this.remaining = Math.max(0, this.remaining - (Date.now() - this.startedAt));
        }
        clearTimeout(this.timer);
        this.timer = null;
        var self = this;
        var canPlay = this.autoplay && !this.userPaused && this.holds.size === 0 &&
          (this.loop || this.index < this.count - 1);
        if (canPlay) {
          this.startedAt = Date.now();
          this.timer = setTimeout(function () { self.next(); }, this.remaining);
          this.setFill(1 - this.remaining / this.delay, this.remaining);
        } else if (this.autoplay) {
          var done = !this.loop && this.index >= this.count - 1;
          this.setFill(done ? 1 : 1 - this.remaining / this.delay, 0);
        }
        if (this.track) this.track.setAttribute('aria-live', this.timer ? 'off' : 'polite');
      }

      next() {
        var i = this.index + 1;
        if (i >= this.count) { if (!this.loop) return; i = 0; }
        this.goTo(i);
      }

      prev() {
        var i = this.index - 1;
        if (i < 0) { if (!this.loop) return; i = this.count - 1; }
        this.goTo(i);
      }

      goTo(i) {
        var n = this.count;
        i = ((i % n) + n) % n;
        this.index = i;
        this.slides.forEach(function (slide, k) {
          var on = k === i;
          slide.classList.toggle('is-active', on);
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !on;
        });
        if (this.mode === 'slide' && this.track) {
          var dir = getComputedStyle(this).direction === 'rtl' ? 1 : -1;
          this.track.style.transform = 'translate3d(' + (dir * 100 * i) + '%,0,0)';
        }
        if (this.currentEl) this.currentEl.textContent = pad(i + 1);
        if (this.fillEl && !this.autoplay) this.fillEl.style.setProperty('--jvh-p', ((i + 1) / n).toFixed(4));
        var keep = this.keepFilled, auto = this.autoplay;
        this.segFills.forEach(function (sf, k) {
          sf.style.transition = 'none';
          sf.style.width = (k === i ? (auto ? 0 : 100) : (keep && k < i ? 100 : 0)) + '%';
        });
        this.dots.forEach(function (dot, k) { dot.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        clearTimeout(this.timer);
        this.timer = null;
        this.remaining = this.delay;
        this.schedule();
      }

      updatePauseBtn() {
        if (!this.pauseBtn) return;
        this.pauseBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
      }
    }

    window.customElements.define('jv-hero-slider', JvHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
